import { customAlphabet } from 'nanoid';

const nanoid = customAlphabet('QWERTYUIOPASDFGHJKLZXCVBNMqwertyuiopasdfghjklzxcvbnm0123456789', 10)

export const normalizeFilesOnUpload = (files) => {
    const obj = {};

    const handleNanoid = () => {
        const id = nanoid();

        return obj.hasOwnProperty(id) ? handleNanoid() : id;
    };

    for (const file of files) {
        const id = handleNanoid();
        const newFile = new File([file], `${id}.${file.type.startsWith('image/') ? 'webp' : 'pdf'}`, {
            type: file.type,
            metadata: file.metadata
        });
        obj[id] = { id, name: file.name, url: URL.createObjectURL(newFile), file: newFile };
    };

    return Object.values(obj);
};

export const normalizeFile = (file, id) => {
    const ext = file.name.split('.').pop();
    const name = file.name.slice(0, file.name.lastIndexOf('.')).replaceAll(' ', '_');
    return {
        name,
        type: file.type,
        data: file,
        redirect: id ? `${id}/${name}.${ext}` : undefined,
    };
};

export const isFileAcceptable = (file, types, maxSize = 5000000) => ({
    bool: types.includes(file.type) && file.size <= maxSize,
    reason: !types.includes(file.type) ? 'invalid file type' : file.size > maxSize ? 'file size exceeded' : ''
});